export const T = {
  en_GB: {
    compliance: "Compliance",
    title: "Flows review",
    description:
      "After-the-fact control of advice flows, with the compliance-relevant facts side by side. Distinct from Flow approvals, which is the in-process gate.",
    advisor: "Advisor",
    period: "Period",
    addFilter: "Add filter",
    choose: "Choose…",
    removeFilter: "Remove filter",
    search: "Search",
    searchPlaceholder: "Search client or flow",
    actions: "Actions",
    flowDefinition: "Flow",
    riskDeviation: "Risk deviation",
    riskNone: "None recorded",
    riskAccepted: "Accepted",
    riskRefused: "Do not proceed",
    riskHint:
      "Read from the advisor's recorded decision. A breach nobody has decided on yet is not stored and cannot be filtered here.",
    mandateDeviation: "Mandate deviation",
    mandateHint:
      "Read from the advisor's recorded mandate decision. A breach nobody has decided on yet is not stored and cannot be filtered here.",
    customPortfolioFilter: "Custom portfolio",
    sustainability: "Sustainability",
    sustainabilityYes: "Important",
    sustainabilityNo: "Not important",
    sustainabilityUnanswered: "Unanswered",
    minAmount: "Amount over",
    totalAmount: "Total amount",
    totalAmountHint: "One-time plus recurring annualised.",
    yesLabel: "Yes",
    noLabel: "No",
    checkStatus: "Review Status",
    checkNotReviewed: "Not reviewed",
    checkFlagged: "Flagged for review",
    checkApproved: "Approved",
    checkNotApproved: "Not approved",
    review: "Review",
    randomLabel: "Spot check",
    randomButton: "Select at random",
    rowCount: (n: string) => `${n} flows`,
    rowCountOne: (n: string) => `${n} flow`,
    selectedCount: (n: string) => `${n} selected`,
    selectRow: "Select flow",
    clearSelection: "Clear",
    markSelected: (n: string) => `Flag ${n} for review`,
    pickupNotePlaceholder: "Why these are being reviewed (required)",
    markSelectedDone: (n: string) => `${n} flow instances flagged for review`,
    markSelectedFailed: "Could not update the selection",
    checkFailed: "Could not save the review",
    period30d: "Last 30 days",
    period90d: "Last 90 days",
    period12m: "Last 12 months",
    periodThisMonth: "This month",
    periodThisQuarter: "This quarter",
    periodThisYear: "This year",
    periodAll: "All time",
    client: "Client",
    flow: "Flow",
    completedAt: "Completed",
    empty: "No flow instances match this filter.",
    unassigned: "Unassigned",
    yes: "Yes",
    no: "No",
  },
  nb_NO: {
    compliance: "Compliance",
    title: "Flytgjennomgang",
    description:
      "Etterkontroll av rådgivningsflyter, med de compliance-relevante fakta side om side. Skiller seg fra Flytgodkjenninger, som er porten underveis.",
    advisor: "Rådgiver",
    period: "Periode",
    addFilter: "Legg til filter",
    choose: "Velg…",
    removeFilter: "Fjern filter",
    search: "Søk",
    searchPlaceholder: "Søk kunde eller flyt",
    actions: "Handlinger",
    flowDefinition: "Flyt",
    riskDeviation: "Risikoavvik",
    riskNone: "Ingen registrert",
    riskAccepted: "Akseptert",
    riskRefused: "Skal ikke fortsette",
    riskHint:
      "Leses fra rådgiverens registrerte beslutning. Et avvik ingen har tatt stilling til lagres ikke og kan ikke filtreres her.",
    mandateDeviation: "Mandatavvik",
    mandateHint:
      "Lest fra rådgiverens registrerte mandatbeslutning. Et brudd ingen har besluttet om ennå lagres ikke og kan ikke filtreres her.",
    customPortfolioFilter: "Egen portefølje",
    sustainability: "Bærekraft",
    sustainabilityYes: "Viktig",
    sustainabilityNo: "Ikke viktig",
    sustainabilityUnanswered: "Ubesvart",
    minAmount: "Beløp over",
    totalAmount: "Totalbeløp",
    totalAmountHint: "Engangsbeløp pluss periodisk beløp annualisert.",
    yesLabel: "Ja",
    noLabel: "Nei",
    checkStatus: "Vurderingsstatus",
    checkNotReviewed: "Ikke vurdert",
    checkFlagged: "Flagget for vurdering",
    checkApproved: "Godkjent",
    checkNotApproved: "Ikke godkjent",
    review: "Vurder",
    randomLabel: "Stikkontroll",
    randomButton: "Velg tilfeldig",
    rowCount: (n: string) => `${n} flyter`,
    rowCountOne: (n: string) => `${n} flyt`,
    selectedCount: (n: string) => `${n} valgt`,
    selectRow: "Velg flyt",
    clearSelection: "Nullstill",
    markSelected: (n: string) => `Flagg ${n} for vurdering`,
    pickupNotePlaceholder: "Hvorfor disse skal vurderes (påkrevd)",
    markSelectedDone: (n: string) => `${n} flytinstanser flagget for vurdering`,
    markSelectedFailed: "Kunne ikke oppdatere utvalget",
    checkFailed: "Kunne ikke lagre vurderingen",
    period30d: "Siste 30 dager",
    period90d: "Siste 90 dager",
    period12m: "Siste 12 måneder",
    periodThisMonth: "Denne måneden",
    periodThisQuarter: "Dette kvartalet",
    periodThisYear: "I år",
    periodAll: "Hele perioden",
    client: "Kunde",
    flow: "Flyt",
    completedAt: "Fullført",
    empty: "Ingen flytinstanser passer dette filteret.",
    unassigned: "Uten rådgiver",
    yes: "Ja",
    no: "Nei",
  },
} as const;
